module.exports = __webpack_public_path__ + "static/media/balls.953cda67.svg";